module.exports = __webpack_public_path__ + "img/location.fd3b98dc.svg";